module.exports = function (fox) {
	'use strict';

	require('./gdprPopups.a.tpl')(fox);
	require('./stylus/gdpr.styl');
	require('./stylus/stripNotification.styl');
	require('./options/gdpr.opt')(fox, fox.jQuery);
};



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/GDPR-popups/index.js
// module id = 106
// module chunks = 5